export const useUserProfileStore = defineStore('userProfileStore', () => {
    const { user } = useUserSession();

    const profile = ref();
    const initialized = ref(false);
    const loading = ref(false);

    const { execute: _fetchProfile } = useNewApiFetch(
        '/api/v1/profile',
        `user:${user.value?.uuid}`,
        {
            immediate: false,
            requiresAuth: true,
            onResponse: ({ response }) => {
                if (!response.ok) {
                    return;
                }

                profile.value = response._data;
            },
        },
    );

    /**
     * Fetches the last used team for the user.
     *
     * @return {*}
     */
    const { execute: _getLastUsedTeam, data: lastUsedTeam } = useNewApiFetch(
        '/api/v1/get-last-used?type=team',
        `user:last-used:${user.value?.uuid}`,
        {
            immediate: false,
            requiresAuth: true,
            transformData: true,
        },
    );

    /**
     * Fetches the last used team for the user.
     *
     * @return {Promise<*>}
     */
    const fetchLastUsedTeam = async () => {
        await _getLastUsedTeam();

        return lastUsedTeam.value;
    };

    /**
     * Fetches the user profile.
     *
     * @param {boolean} [force=false]
     * @return {*}
     */
    const fetchProfile = async (force: boolean = false) => {
        // No logged in user, no profile to fetch
        if (!user.value || !user.value.uuid || loading.value) {
            return;
        }

        // If already initialized and not forcing, do not re-fetch
        if (initialized.value && !force) {
            return;
        }

        loading.value = true;

        const [err, _] = await catchError(_fetchProfile());

        loading.value = false;
        if (!err) {
            initialized.value = true;
        }
    };

    const refreshProfile = async () => {
        loading.value = true;

        await fetchProfile(true);

        loading.value = false;
    };

    const unload = () => {
        profile.value = undefined;
        initialized.value = false;
        loading.value = false;
    };

    return {
        profile,
        initialized,
        loading,
        lastUsedTeam,
        fetchProfile,
        refreshProfile,
        fetchLastUsedTeam,
        unload,
    };
});
